import { UploadImages } from "components/forms/uploadImages";
import { ImageGalleryMenuBar } from "components/layout/MenuBar";
import Nav from "components/layout/Nav";
import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";


const Components = {
    UPLOAD_IMAGES: 'uploadImages',
    MANAGE_IMAGES: 'manageImages',
}
const ImageGallery = () => {
    const { folderName } = useParams();
    const [activeComponent, setActiveComponent] = useState(Components.UPLOAD_IMAGES);
    const renderComponent = () => {
        let storedFolderId = localStorage.getItem("openedFolderId");
    
        if (storedFolderId || (folderName && folderName !== "home")) {
            return <UploadImages />;
        }
    
        return <UploadImages />; // Default case for consistency
    };
    
    

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Image Gallery</title>
            </Helmet>
            <Nav />
            <div className="row">
                <ImageGalleryMenuBar setActiveComponent={setActiveComponent} />
                <main style={{ width: "calc(100vw - 240px)", backgroundColor: "#D0D5DD" }}>
                    {renderComponent()}
                </main>
            </div>
        </>
    )
}

export default ImageGallery;